import React from "react";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrowLeft.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import AILogo from "../../assets/images/ai.svg";
import auditLogo from "../../assets/images/audit.svg";
import detectionQualityLogo from "../../assets/images/detection.svg";
import evaluationLogo from "../../assets/images/evaluation.svg";
import knowledgeLogo from "../../assets/images/knowledge.svg";
import taskLogo from "../../assets/images/ticket.svg";
import trackingLogo from "../../assets/images/tracking.svg";
import userManagementLogo from "../../assets/images/users.svg";
import workloadLogo from "../../assets/icons/chart.svg";
import heatmapLogo from "../../assets/icons/heat.svg";
import { useTranslation } from "react-i18next";
import { logActivity } from "../../helpers/activityLog";

import "./SupportingApp.scss";
import Chatbot from "../../components/Chatbot/Chatbot";

const SupportingApp = () => {
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const { user } = auth;

  // Check if user has admin role
  const isAdmin =
    user?.roles?.includes("Administrator") || user?.roles?.includes("admin");

  return (
    <div className='SupportingApp'>
      <Chatbot />
      <div className='left'></div>
      <div className='right'>
        <Link to='/'>
          <ArrowLeftIcon className='back' title='Back' />
        </Link>
        <h1>{t("Supporting Program")}</h1>

        <div className='apps'>
          <a
            href='/MashhadAi'
            className='app green'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened MashhadAi from Landing Page",
                moduleName: "MashhadAi",
              })
            }
          >
            <div className='app_img'>
              <img src={AILogo} alt='Mashhad Logo' />
            </div>
            <div className='app_content'>
              <p>MashhadAi</p>
            </div>
          </a>

          <a
            href='/Ticketing'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Task Management from Landing Page",
                moduleName: "Task Management",
              })
            }
          >
            <div className='app_img'>
              <img src={taskLogo} alt='SS Logo' />
            </div>
            <div className='app_content'>
              <p>Task Management</p>
            </div>
          </a>

          <a
            href='/Tracking'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Tracking from Landing Page",
                moduleName: "Tracking",
              })
            }
          >
            <div className='app_img'>
              <img src={trackingLogo} alt='SS Logo' />
            </div>
            <div className='app_content'>
              <p>Tracking</p>
            </div>
          </a>

          <a
            href='/DetectionQuality'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription:
                  "Opened Detection Quality from Landing Page",
                moduleName: "Detection Quality",
              })
            }
          >
            <div className='app_img'>
              <img src={detectionQualityLogo} alt='Detection Quality Logo' />
            </div>
            <div className='app_content'>
              <p>Detection Quality</p>
            </div>
          </a>

          {/* <a href='/Evaluation' className='app'>
            <div className='app_img'>
              <img src={evaluationLogo} alt='Audit Logo' />
            </div>
            <div className='app_content'>
              <p>Evaluation</p>
            </div>
          </a> */}

          <a
            href='/Auditing'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Audit from Landing Page",
                moduleName: "Audit",
              })
            }
          >
            <div className='app_img'>
              <img src={auditLogo} alt='Audit Logo' />
            </div>
            <div className='app_content'>
              <p>Audit</p>
            </div>
          </a>
          {isAdmin && (
            <a
              href='/user-management'
              className='app'
              onClick={() =>
                logActivity({
                  eventCategory: "Supporting Program",
                  eventDescription:
                    "Opened User Management from Landing Page",
                  moduleName: "User Management",
                })
              }
            >
              <div className='app_img'>
                <img src={userManagementLogo} alt='User Logo' />
              </div>
              <div className='app_content'>
                <p>User Management</p>
              </div>
            </a>
          )}
          <a
            href='/evaluation'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Evaluation from Landing Page",
                moduleName: "Evaluation",
              })
            }
          >
            <div className='app_img'>
              <img src={evaluationLogo} alt='Evaluation Logo' />
            </div>
            <div className='app_content'>
              <p>Evaluation</p>
            </div>
          </a>

          <Link
            to='/SupportingApp/KnowledgeCenter'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription:
                  "Opened Knowledge Center from Landing Page",
                moduleName: "Knowledge Center",
              })
            }
          >
            <div className='app_img'>
              <img src={knowledgeLogo} alt='Knowledge Center Logo' />
            </div>
            <div className='app_content'>
              <p>Knowledge Center</p>
            </div>
          </Link>

          <a
            href='/Workload'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Workload from Landing Page",
                moduleName: "Workload",
              })
            }
          >
            <div className='app_img'>
              <img src={workloadLogo} alt='Workload Logo' />
            </div>
            <div className='app_content'>
              <p>{t("Workload")}</p>
            </div>
          </a>

          <a
            href='/heatmap'
            className='app'
            onClick={() =>
              logActivity({
                eventCategory: "Supporting Program",
                eventDescription: "Opened Heatmap from Landing Page",
                moduleName: "Heatmap",
              })
            }
          >
            <div className='app_img'>
              <img src={heatmapLogo} alt='Heatmap Logo' />
            </div>
            <div className='app_content'>
              <p>Heatmap</p>
            </div>
          </a>

          {/* <a href='/Reporting' className='app'>
            <div className='app_img'>
              <img src={invoiceLogo} alt='SS Logo' />
            </div>
            <div className='app_content'>
              <p>Reporting</p>
            </div>
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default SupportingApp;
